import * as React from 'react';
import Quiz from './AdminQuiz';

interface Props {
    onQuizCreate: (quiz: Bee.Quiz) => any;
    match: {
        path: string;
        params: any;
    };
    history: { push: (path: string) => void; };
    location: { hash: string };
    classes: {
        container: string;
        date: string;
        question: string;
        divider: string;
        preview: string;
        remove: string;
        questionBtn: string;
        questionBtns: string;
    };
}

class CreateQuiz extends React.Component<Props, {}> {
  	render() {
        return (
            <Quiz {...this.props} create />
        )
	}
}

export default CreateQuiz;



// WEBPACK FOOTER //
// ./src/components/Admin/CreateQuiz.tsx